export const DEFAULT_PAGES = Object.freeze(
  [
    {
      page: 'indemnity',
      config: {},
      'indemnity-0': false,
    },
    {
      page: 'government-data',
      config: {},
    },
    {
      page: 'business-data',
      config: {},
    },
    {
      page: 'user-data',
    },
    {
      page: 'phone-number',
      config: {},
    },
    {
      page: 'email',
      config: {},
    },
    {
      page: 'business-id',
      config: {},
    },
    {
      page: 'address',
      config: {},
    },
    {
      page: 'id',
      config: {},
    },
    {
      page: 'selfie',
      config: {type: 'basic'},
    },
    {
      page: 'additional-document',
      config: {},
    },
    {
      page: 'signature',
      config: {},
    },
    {
      page: 'custom-questions',
      config: {},
    },
  ].map((page, index) => ({
    ...page,
    pageId: index,
  })),
);

export const DEFAULT_FRAUD_PAGES = [
  {
    page: 'user_data',
    user_data: {
      // fields: ['first_name'],
      action: 'pending',
      two_names_rule: false,
    },
  },
  {
    page: 'age_limit',
    age_limit: {
      limit: 18,
      action: 'pending',
    },
  },
  {
    page: 'liveness_match',
    liveness_match: {
      // glassesCheck: true,
      // brightnessThreshold: 40,
      image_match: {
        failed: [0, 24],
        pending: [25, 65],
        successful: [66, 100],
      },
      liveness_score: {
        failed: [0, 24],
        pending: [25, 65],
        successful: [66, 100],
      },
      // action: 'pending',
    },
  },
  {
    page: 'aml_screening',
    aml_screening: {
      action_returned: 'pending',
      category: ['pep', 'warning'],
      match_score: 50,
    },
  },
  {
    page: 'duplicate_check',
    duplicate_check: {
      action_returned: 'blocked',
      resume_verification: false,
    },
  },
  {
    page: 'ip_screening',
    ip_screening: {
      action_blacklisted: 'pending',
    },
  },
  {
    page: 'digital_address',
    digital_address: {
      action: 'pending',
    },
  },
];
